/**
 * Assemble des classes. Les valeurs fausses disparaissent, ce qui evite les
 * `undefined` dans un attribut `class` quand une classe de module manque.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
